import {Button, Checkbox, Col, Form, Input, Row, Spin} from 'antd';
import {LockOutlined, UserOutlined, LoadingOutlined} from '@ant-design/icons';
import localStorageUtils from '../../utils/localStoraegUtils';
import {login} from './authSlice';
import styles from './Login.module.css';
import {useAppDispatch, useAppSelector} from '../../common/hooks';
import {USER} from './auth.type';

type FORM_PAYLAOD = {
  username: string;
  password: string;
  remember: boolean;
};
const Login = () => {
  const dispatch = useAppDispatch();
  const state: {isLoading: boolean; user: USER} = useAppSelector((state) => state.auth);
  const onFinish = (values: FORM_PAYLAOD) => {
    values.remember === true
      ? localStorage.setItem('remember', JSON.stringify(values))
      : localStorage.removeItem('remember');

    dispatch(login({username: values.username, password: values.password}));
  };

  return (
    <Row className={styles.main}>
      <Col span={8} className={styles.form_wrapper}>
        <Spin
          size='large'
          spinning={state.isLoading}
          indicator={<LoadingOutlined style={{fontSize: 64}} spin />}
        >
          <Row>
            <Col span={24}>
              <div style={{textAlign: 'center'}}>
                <img style={{maxWidth: '400px'}} src='batswap.png' alt='logo' />
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form
                name='normal_login'
                className='login-form'
                initialValues={{
                  username: localStorageUtils.get('remember')
                    ? JSON.parse(localStorageUtils.get('remember')).username
                    : null,
                  password: localStorageUtils.get('remember')
                    ? JSON.parse(localStorageUtils.get('remember')).password
                    : null,
                  remember: true,
                }}
                onFinish={onFinish}
              >
                <Form.Item
                  name='username'
                  rules={[{required: true, message: 'Please input your Username!'}]}
                >
                  <Input
                    prefix={<UserOutlined className='site-form-item-icon' />}
                    placeholder='Username'
                    size='large'
                    style={{borderRadius: '6px'}}
                  />
                </Form.Item>
                <Form.Item
                  name='password'
                  rules={[{required: true, message: 'Please input your Password!'}]}
                >
                  <Input.Password
                    prefix={<LockOutlined className='site-form-item-icon' />}
                    placeholder='Password'
                    size='large'
                    style={{borderRadius: '6px'}}
                  />
                </Form.Item>
                <Form.Item>
                  <Form.Item name='remember' valuePropName='checked' noStyle>
                    <Checkbox>Remember me</Checkbox>
                  </Form.Item>

                  <a className={styles.login_form_forgot} href=''>
                    Forgot password
                  </a>
                </Form.Item>

                <Form.Item>
                  <Button type='primary' htmlType='submit' className={styles.login_form_button}>
                    Log in
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Spin>
      </Col>
    </Row>
  );
};

export default Login;
